import { Footer } from 'antd/es/layout/layout';
import React from 'react';

interface DateInformationFooterProps {}

const DateInformationFooter: React.FC<DateInformationFooterProps> = () => {

    return (
    <Footer style={{ fontSize: '12px', textAlign: 'center', padding: '50px', width: '100%', bottom: 0,  color: 'grey', backgroundColor: 'transparent' }}>
      <p>All times are calculated using Eastern Standard Time (EST).
      </p>
    </Footer>
  );
};

export default DateInformationFooter;